customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super()
    
    this.formElement = this.querySelector('form');
    this.formElement.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(evt) {
      if(this.closest('.customiser__outer').classList.contains('open')) {
        evt.preventDefault();
        var linePropertyItems = this.closest('.customiser__outer').querySelectorAll('.line_item');

        for (const key in storedProperties) {
          delete storedProperties[key];
        }
        
        for(i=0; i < linePropertyItems.length; i++) {
          var property = linePropertyItems[i].getAttribute("name").split('[').pop().split(']')[0],
              value = linePropertyItems[i].value;

          console.log(value);

          if (value) {
            storedProperties[property] = value;
          }
        }
        
        fetch("/cart/add.json", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
            id: this.querySelector('.badge.active').dataset.id,
            quantity: 1,
            properties: storedProperties
          })
        }).then(response => {
          if(response.ok) {
            return response.json();
          }
          throw new Error('Request Failed!');
        }, networkError => console.log(networkError.message)
        ).then((response) => {
          console.log('Product(s) Added')

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: response,
              addToCartBtn: this.querySelector('.product-form__submit')
            }
          }));
        })
        .catch((e) => {
          console.error(e);
        })
      }
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
})
